export default __webpack_public_path__ + "static/media/one-hundred-percent.f701be78.svg";